import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../components/HeaderLanding/Header';
import Footer from '../../components/FooterLanding/Footer';

const PublicLayout = () => {
    return (
        <>
            <style>{`
        /* Scroll personalizado para rutas públicas */
        .public-scroll::-webkit-scrollbar {
            width: 6px;
        }
        .public-scroll::-webkit-scrollbar-track {
            background: transparent;
        }
        .public-scroll::-webkit-scrollbar-thumb {
            background-color: rgba(97, 37, 123, 0.3);
            border-radius: 20px;
            transition: background-color 0.2s;
        }
        .public-scroll::-webkit-scrollbar-thumb:hover {
            background-color: rgba(97, 37, 123, 0.5);
        }

        /* Firefox */
        .public-scroll {
            scrollbar-width: thin;
            scrollbar-color: rgba(97, 37, 123, 0.3) transparent;
        }

        /* También aplicar al html/body cuando este layout está activo */
        html, body {
            scrollbar-width: thin;
            scrollbar-color: rgba(97, 37, 123, 0.3) transparent;
        }
        html::-webkit-scrollbar {
            width: 6px;
        }
        html::-webkit-scrollbar-track {
            background: transparent;
        }
        html::-webkit-scrollbar-thumb {
            background-color: rgba(97, 37, 123, 0.3);
            border-radius: 20px;
        }
        html::-webkit-scrollbar-thumb:hover {
            background-color: rgba(97, 37, 123, 0.5);
        }
      `}</style>

            <Header />
            <main style={{ paddingTop: 0, minHeight: '100vh', position: 'relative' }}>
                <Outlet />
            </main>
            <Footer />
        </>
    );
};

export default PublicLayout;